import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';
import { CreateInvestigationFormDraftVersionQuery } from './create-investigation-form-draft-version.query';

@Injectable({ providedIn: 'root' })
export class CreateInvestigationFormDraftVersionUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(query: CreateInvestigationFormDraftVersionQuery): Observable<{ versionId: string }> {
    this._state.setLoadingInvestigationForm(true);
    this._state.clearErrorInvestigationForm();

    return this._repository.createInvestigationFormDraftVersion(query.formId).pipe(
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to create draft version for form ${query.formId}`;
        this._state.setErrorInvestigationForm(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingInvestigationForm(false))
    );
  }
}
